module.exports = __webpack_public_path__ + "static/media/Heart_OFF@3x.bff886d5.png";